export const formatIDR = (n) => {
  const v = Number(n || 0);
  return "Rp." + v.toLocaleString("id-ID", { maximumFractionDigits: 0 });
};

export const formatRupiah = (n) => "Rp " + Math.round(Number(n || 0)).toLocaleString("id-ID");

export const formatRupiahShort = (n) => {
  const v = Number(n || 0);
  if (v >= 1_000_000_000) return "Rp " + (v / 1_000_000_000).toLocaleString("id-ID", { maximumFractionDigits: 1 }) + " M";
  if (v >= 1_000_000) return "Rp " + (v / 1_000_000).toLocaleString("id-ID", { maximumFractionDigits: 1 }) + " jt";
  return formatRupiah(v);
};

export const formatIDRShort = (n) => {
  const v = Number(n || 0);
  if (v >= 1_000_000_000) return "Rp." + (v / 1_000_000_000).toFixed(1) + " M";
  if (v >= 1_000_000) return "Rp." + (v / 1_000_000).toFixed(0) + " Jt";
  if (v >= 1_000) return "Rp." + (v / 1_000).toFixed(0) + " Rb";
  return "Rp." + v.toLocaleString("id-ID");
};

export const formatDate = (iso) => {
  if (!iso) return "-";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  if (isNaN(d.getTime())) return "-";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = d.getFullYear();
  return `${dd}/${mm}/${yy}`;
};

export const formatDateLong = (iso) => {
  if (!iso) return "-";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  if (isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });
};

export const daysUntil = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  const now = new Date();
  d.setHours(0, 0, 0, 0); now.setHours(0, 0, 0, 0);
  return Math.round((d - now) / (1000 * 60 * 60 * 24));
};

export const clientName = (c) => {
  if (!c) return "-";
  const parts = [c.bride_name, c.groom_name].filter(Boolean);
  return parts.join(" & ");
};

export const formatApiError = (detail) => {
  if (detail == null) return "Terjadi kesalahan.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
};
